import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
  button: {
    color: 'blue',
    cursor: 'pointer',
  },
});
const ViewMore = ({ children, maxCharacterLength = 50 }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const classes = styles();

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  const textToShow = isExpanded
    ? children
    : children?.slice(0, maxCharacterLength);

  return (
    <p>
      {textToShow}
      {children?.length > maxCharacterLength && (
        <span onClick={handleClick} className={classes.button}>
          &nbsp;
          {isExpanded ? 'Show less' : 'View more'}
        </span>
      )}
    </p>
  );
};

ViewMore.propTypes = {
  children: PropTypes.string.isRequired,
  maxCharacterLength: PropTypes.number,
};

export default ViewMore;
